import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { SITE_URL } from "@/components/schemaConstants";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "SAINT® TMS Coral Springs | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "FDA-cleared, fMRI-guided 5-day SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL. Free consultation.",
      },
      {
        property: "og:title",
        content: "SAINT® TMS Coral Springs | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "FDA-cleared, fMRI-guided 5-day SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL.",
      },
      { property: "og:url", content: SITE_URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: SITE_URL },
      { rel: "alternate", hrefLang: "en", href: SITE_URL },
      { rel: "alternate", hrefLang: "es", href: `${SITE_URL}/es` },
      { rel: "alternate", hrefLang: "x-default", href: SITE_URL },
    ],
  }),
  component: HomePage,
});

function HomePage() {
  return <Index />;
}
